import React from 'react'
import { ResponsiveBar } from '@nivo/bar'
// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const calcColor = (level) => {
    if (level > 0 && level <= 20) {
        return "#e7233d";
    }
    else if (level > 20 && level <= 40) {
        return "#8e0666";
    }
    else if (level > 40 && level <= 60) {
        return "#f56f3f";
    }
    else if (level > 60 && level <= 80) {
        return "#feb743";
    }
    else if (level > 80 && level <= 100) {
        return "#18ee97";
    }
    else {
        return "#00000000";
    }
};

const generatePerceptionComment = (percent) => {
    if (percent > 0 && percent <= 20) {
        return "Extremely Urgent Attention Needed";
    } else if (percent > 20 && percent <= 40) {
        return "Urgent Attention Needed";
    } else if (percent > 40 && percent <= 60) {
        return "Moderate Attention Needed";
    } else if (percent > 60 && percent <= 80) {
        return "Low Attention Needed";
    } else {
        return "No Attention Needed";
    }
} // end generateperception comment
const BarGraph = (props) => (
    <ResponsiveBar
        data={props.data}
        keys={props.keys}
        indexBy={props.xKey}
        margin={{ top: 40, right: 40, bottom: 100, left: 40 }}
        padding={0.5}
        groupMode="grouped"
        minValue = {0}
        maxValue = {100}
        colors={(bar) => calcColor(bar.value)}
        theme={{
            axis: {
                fontSize: "14px",
                tickColor: "#eee",
                ticks: {
                    line: {
                        stroke: "#e7233d"
                    },
                    text: {
                        fill: "#ffffff"
                    }
                },
                legend: {
                    text: {
                        fill: "#ffffff",
                        fontFamily: "Roboto Condensed",
                        fontWeight: 'normal',
                        fontSize: '16px'
                    }
                }
            },
            grid: {
                line: {
                    stroke: "#999"
                }
            }
        }}
        borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -30,
            legend: 'Assessments',
            legendPosition: 'middle',
            legendOffset: 60
        }}
        axisLeft={null}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        legends={[]}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        tooltip={ (bar) => {
            return(
                <div
                    style={{
                        padding: '8px',
                        backgroundColor: calcColor(bar.data.perceptionLevel),
                        color: '#000',
                        borderRadius: '5px',
                        width: "320px",
                        height: "80px",
                        font: 'italic normal 18px Roboto Condensed'
                    }}
                >
                    <span><strong>Assessment: </strong>{bar.data.assessment}</span><br />
                    <span><strong>Perception Level: </strong>{generatePerceptionComment(bar.data.perceptionLevel)}</span>
                </div>
            )
         }}
    />
)

export default BarGraph;


// WEBPACK FOOTER //
// ./src/components/DataViz/BarGraph/BarGraph.jsx